module.exports = __webpack_public_path__ + "img/background028.13bc5929.jpg";